<template>
  <form class="form__newsletter" v-bind:class="getClass()" @submit.prevent="submitForm">
    <input type="hidden" name="source" :value="source"/>
    <input type="hidden" name="gorilla.csrf.Token" :value="csrftoken"/>
    <input type="hidden" name="flags" :value="flags"/>

    <emailInput
      ref="emailInputComponent"
      v-if="showEmailInput"
      v-model="email"
      @onEmailFocus="onEmailFocus"
      @onEmailBlur="onEmailBlur"
      @clearForm="clearForm"
      :enteredClass=enteredClass
      :placeholder=placeholder
      :useAccentColor=useAccentColor
      :hasFocus=hasFocus
      :inputIsEmpty=inputIsEmpty>
    </emailInput>
    <subscribedButton v-if="showSubscribedButton" @clearForm="clearForm" ref="xButton"></subscribedButton>
  </form>
</template>

<script>
import subscribedButton from "./subscribed-button.vue";
import emailInput from "./email-input.vue";

export default {
  components: {
    subscribedButton,
    emailInput
  },
  props: ['source', 'flags', 'placeholder', 'optin'],
  mounted() {
    this.csrftoken = document.querySelector('meta[name="csrf-token"]').content;
  },
  data: function() {
    return {
      showSubscribedButton: false,
      showEmailInput: true,
      useAccentColor: false,
      email: '',
      postError: false,
      hasFocus: false,
      enteredClass: '',
      csrftoken: '',
      inputIsEmpty: true,
    }
  },
  watch: {
    email(emailText) {
      if (emailText.length > 0) {
        this.enteredClass = "form__newsletter__input--entered";
        this.inputIsEmpty = false;
      } else {
        this.enteredClass = "";
        this.inputIsEmpty = true
      }
    }
  },
  methods: {
    onEmailFocus() {
      this.useAccentColor = true;
    },
    onEmailBlur() {
      this.email = event.target.value;
      if (this.email == "") {
        this.hasFocus = false
        this.useAccentColor = false;
      }
    },
    clearForm() {
      this.email = "";
      this.showSubscribedButton = false;
      this.showEmailInput = true;
      this.hasFocus = true
    },
    getClass() {
      if (this.useAccentColor) {
        return "accent-color--border";
      }
    },
    submitForm() {
      fetch("/newsletters/subscribe/", {
        method: 'POST',
        type: 'POST',
        processData: false,
        headers: {
          "X-CSRF-Token": this.csrftoken,
          "Content-Type": "application/json"
        },
        body: JSON.stringify({ email: this.email, source: this.source, flags: this.flags, optin: this.optin })
      })
      .then((res) => {
        this.showSubscribedButton = true;
        this.showEmailInput = false;
        this.useAccentColor = false;

        if (window.ScarabQueue) {
          window.ScarabQueue.push(['setEmail', this.email]);
          window.ScarabQueue.push(['go']);
        }

        window.dataLayer = window.dataLayer || [];

        window.dataLayer.push({
          event: 'gtm.SubmitNewsletter',
          source: this.source,
        });
      })
      .catch((err)=> {
        console.log(err);
      })
      .then(() => {
        this.$refs.xButton.$el.focus();
      });
    }
  }
};
</script>
